import {DialogController} from 'aurelia-dialog';
import {inject} from "aurelia-framework";
import {FormField} from "../../../form/object/form-field";

@inject(
    DialogController
)
export class SelectMediaBundleView {
    constructor(
        dialogController
    ) {
        this.dialogController = dialogController;

        this.bundleField = null;
        this.title       = null;
        this.loading     = false;
    }

    async activate(context)
    {
        const dummyFormService = { change: () => {} };

        const fieldConfig = {
            'type': 'choice',
            'modelId': 'media-database/media-bundle',
            'multiple': context.multiple ?? true,
            'required': true,
            'label': 'media_database.media-bundle',
            'hideCreateAction': true,
        };

        if (context.bundles) {
            fieldConfig.conditions = {
                id: { $in: context.bundles.map(b => b.id) }
            };
        }

        this.bundleField = new FormField(
            dummyFormService,
            fieldConfig,
            'mediaBundle',
            null
        );

        this.title = context.title;
        this.onSave = context.onSave;
        this.loading = false;
    }

    async ok()
    {
        this.loading = true;

        return this.onSave({
            bundle: this.bundleField.getValue(),
        }).then(() => {
            return this.dialogController.ok();
        }).catch((error) => {
            this.loading = false;
            throw error;
        });
    }
}
